<template>
  <div>
    <lida-table
      :propscolumns="columns(false)"
      :data="totalItems"
      :sortStatus="false"
      align="right"
      :SpinLoading="loading"
      :propsPageSize="50"
      class="my-2"
      :LeaveSpace="false"
      :mytlpa="mytlpa"
    >
      <template v-slot:headerSelect>
        <p class="title text-left">全部</p>
      </template>
    </lida-table>
    <lida-table
      v-for="(it, key) in totalData"
      :key="key"
      :propscolumns="columns(true, key)"
      :data="it"
      :sortStatus="false"
      align="right"
      :SpinLoading="loading"
      :propsPageSize="50"
      class="my-2"
      :LeaveSpace="false"
      :page="false"
      :ref="[`table${key}`]"
      :mytlpa="mytlpa"
    >
      <template v-slot:headerSelect>
        <p class="title text-left">{{getGamename(key)}}</p>
      </template>
    </lida-table>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import switchHie from "../mixins/switchHie.js"
import reportCount from '@/mixins/report-count.js'
export default {
  name: 'reporta5',
  mixins: [reportCount, switchHie],
  data () {
    return {
      totalData: [],
      notSunArray: ['hie', 'iscash1', 'mid', 'memcou', 'l6username', 'l6name', 'l5p'],
      loading: false
    }
  },
  computed: {
    ...mapGetters(['getmember', 'lidaTableCheck']),
  },
  created () {
    this.getmytlpa()
    this.getTableData()
  },
  methods: {
    async getTableData () {
      this.loading = true
      try {
        const data = {
          ...this.query,
          stid: this.query.stidlist || this.query.stid,
          repnum: 5,
        }
        const res = await this.$axios.generalLedger.linkreporta2_9(data)
        if ('status' in res && res.status === 0) return
        this.totalData = { ...this.itemsDefault(), ...res }
        this.sunTotal({ name: 'l6name', name2: 'l6username' })
        this.TableScrollTop()
        this.itemsSort()
      } catch (error) {
        console.error(error);
        this.checkUrl(error)
      } finally {
        this.loading = false
      }
    },
    columns (status = true, gameid) {
      const object = {
        indexNumber: {
          title: '序号',
          align: 'center',
          key: 'indexNumber',
          width: 40
        },
        l6name: {
          title: '代理',
          align: 'center',
          key: 'l6name',
          totaltext: '总计',
          notetext: '本占比总计',
          minWidth: 50,
          render: (h, params) => {
            if (this.checkFooterText(params.row.l6name)) {
              return params.row.l6name == '本占比总计'
                ? h('span', `${params.row.l6name} (${this.mytlpa}%)`)
                : h('span', params.row.l6name)
            } else {
              return h('a', {
                on: {
                  click: () => this.$router.push({
                    name: `general-ledger-reporta${params.row.hie}`,
                    query: { ...this.query, gameid, mid: params.row.mid, lastLevel: 5, },
                    params: { scrollGameid: gameid }
                  })
                }
              },
                [
                  h('span', { class: { pc3: true, 'word-break': true } }, params.row.l6name),
                  h('span', { class: { pc2: true, 'word-break': true } }, ` ${params.row.l6username}`)
                ])
            }

          },
        },
        cou: {
          title: '注数',
          align: 'center',
          key: 'cou',
          total: true,
          minWidth: 2,
          render: (h, params) => h('span', this.$commaFormat(params.row.cou))
        },
        memcou: {
          title: '会员数',
          align: 'center',
          key: 'memcou',
          total: true,
          width: this.lidaTableCheck ? 40 : 100,
        },
        value: {
          title: '下注金额',
          align: 'center',
          key: 'value',
          total: true,
          note: true,
          minWidth: 20,
          render: (h, params) => this.renderColorAmount(h, params, 'value')
        },
        effval: {
          title: '有效额',
          align: 'center',
          key: 'effval',
          className: 'trigger-show',
          triggerShow: true,
          total: true,
          note: true,
          minWidth: 20,
          render: (h, params) => {
            const value = params.row.effval * -1
            return h('p', this.NegativeColor(value), this.toDecimal2(value))
          }
        },
        hie: {
          title: '会员奖金',
          align: 'center',
          key: 'hie',
          className: 'trigger-show',
          triggerShow: true,
          total: true,
          note: true,
          minWidth: 30,
          render: (h, params) => {
            const value = params.row.mpaysum - params.row.payds
            return h('p', this.NegativeColor(value), this.toDecimal2(value))
          }
        },
        payds: {
          title: '会员佣金',
          align: 'center',
          key: 'payds',
          className: 'trigger-show ',
          triggerShow: true,
          total: true,
          note: true,
          render: (h, params) => this.renderColorAmount(h, params, 'payds')
        },
        mpaysum: {
          title: '会员盈亏',
          align: 'center',
          key: 'mpaysum',
          total: true,
          note: true,
          minWidth: 30,
          render: (h, params) => this.renderColorAmount(h, params, 'mpaysum')
        },
        l6pays: {
          title: '代理占成',
          align: 'center',
          key: 'l6pays',
          className: 'trigger-show',
          triggerShow: true,
          total: true,
          note: true,
          render: (h, params) => this.renderColorAmount(h, params, 'l6pays')
        },
        l6upps: {
          title: '代理占成上缴',
          align: 'center',
          key: 'l6upps',
          total: true,
          note: true,
          minWidth: 30,
          render: (h, params) => this.renderColorAmount(h, params, 'l6upps')
        },
        l6upt: {
          title: '代理上缴',
          align: 'center',
          key: 'l6upt',
          total: true,
          note: true,
          minWidth: 30,
          render: (h, params) => this.renderColorAmount(h, params, 'l6upt')
        },
        l6bkpds: {
          title: '代理退佣',
          align: 'center',
          key: 'l6bkpds',
          className: 'trigger-show',
          triggerShow: true,
          total: true,
          note: true,
          render: (h, params) => this.renderColorAmount(h, params, 'l6bkpds')
        },
        l6paysum: {
          title: '代理盈亏',
          align: 'center',
          key: 'l6paysum',
          className: 'trigger-show',
          triggerShow: true,
          total: true,
          note: true,
          minWidth: 30,
          render: (h, params) => this.renderColorAmount(h, params, 'l6paysum')
        },
        l5p: {
          title: '总代占成(%)',
          align: 'center',
          key: 'l5p',
          total: true,
          width: this.lidaTableCheck ? 40 : 100,
          render: (h, params) => {
            return !this.checkFooterText(params.row.l6name) ? h('p', `${params.row.l5p > 0 ? params.row.l5p : 0}%`) : null
          }
        },
        l5pays: {
          title: '总代占成',
          align: 'center',
          key: 'l5pays',
          total: true,
          note: true,
          minWidth: 30,
          render: (h, params) => this.renderColorAmount(h, params, 'l5pays')
        },

        l5pdsd: {
          title: '总代佣金差',
          align: 'center',
          key: 'l5pdsd',
          total: true,
          note: true,
          render: (h, params) => this.renderColorAmount(h, params, 'l5pdsd')
        },
        l5paysum: {
          title: '总代盈亏',
          align: 'center',
          key: 'l5paysum',
          total: true,
          note: true,
          minWidth: 30,
          render: (h, params) => this.renderColorAmount(h, params, 'l5paysum')
        },
        l5upps: {
          title: '总代占成上缴',
          align: 'center',
          key: 'l5upps',
          total: true,
          note: true,
          minWidth: 30,
          render: (h, params) => this.renderColorAmount(h, params, 'l5upps')
        },
        l5upt: {
          title: '总代上缴',
          align: 'center',
          key: 'l5upt',
          total: true,
          note: true,
          minWidth: 30,
          render: (h, params) => this.renderColorAmount(h, params, 'l5upt')
        },
        l5bkpds: {
          title: '总代退佣',
          align: 'center',
          key: 'l5bkpds',
          className: 'trigger-show',
          triggerShow: true,
          total: true,
          note: true,
          render: (h, params) => this.renderColorAmount(h, params, 'l5bkpds')
        },

        l5paysumt: {
          title: '总代占成盈亏',
          align: 'center',
          key: 'l5paysumt',
          className: 'trigger-show',
          triggerShow: true,
          total: true,
          note: true,
          minWidth: 30,
          render: (h, params) => this.renderColorAmount(h, params, 'l5paysumt')
        },
        l5pds: {
          title: '总代赚佣',
          align: 'center',
          key: 'l5pds',
          className: 'trigger-show',
          triggerShow: true,
          total: true,
          note: true,
          render: (h, params) => this.renderColorAmount(h, params, 'l5pds')
        },
        l4pays: {
          title: '股东占成',
          align: 'center',
          key: 'l4pays',
          className: 'trigger-show',
          triggerShow: true,
          total: true,
          note: true,
          minWidth: 30,
          render: (h, params) => this.renderColorAmount(h, params, 'l4pays')
        },
        l4upps: {
          title: '股东上缴成占成',
          align: 'center',
          key: 'l4upps',
          className: 'trigger-show',
          triggerShow: true,
          total: true,
          note: true,
          minWidth: 30,
          render: (h, params) => this.renderColorAmount(h, params, 'l4upps')
        },
        l4bkpds: {
          title: '股东退佣',
          align: 'center',
          key: 'l4bkpds',
          className: 'trigger-show',
          triggerShow: true,
          total: true,
          note: true,
          render: (h, params) => this.renderColorAmount(h, params, 'l4bkpds')
        },
        l4paysum: {
          title: '股东盈亏',
          align: 'center',
          key: 'l4paysum',
          className: 'trigger-show',
          triggerShow: true,
          total: true,
          note: true,
          minWidth: 30,
          render: (h, params) => this.renderColorAmount(h, params, 'l4paysum')
        },
      }
      if (!status) delete object.memcou
      return object
    }
  }
}
</script>